//
// This file is AUTO-GENERATED by protoc-gen-ts.
// Do not modify it manually.
///
import api from '../../api'
import * as googleTypes from '../../googleTypes'
import { Empty as arangodb_cloud_common_v1_Empty } from '../../common/v1/common'
import { ListOptions as arangodb_cloud_common_v1_ListOptions } from '../../common/v1/common'
import { Version as arangodb_cloud_common_v1_Version } from '../../common/v1/common'

// File: usage/v1/usage.proto
// Package: arangodb.cloud.usage.v1

// Aggregated Billing 2.0 credit consumption.
export interface CreditUsage {
  // Aggregated buckets, ordered ascending by period_start.
  // CreditUsageBucket
  buckets?: CreditUsageBucket[];
  
  // Total credits consumed over the whole requested period.
  // number
  total_credits?: number;
}

// A single aggregated bucket of credit consumption.
export interface CreditUsageBucket {
  // Start of the period covered by this bucket, in UTC.
  // googleTypes.Timestamp
  period_start?: googleTypes.Timestamp;
  
  // Deployment covered by this bucket.
  // Empty unless group_by_deployment was set on the request.
  // string
  deployment_id?: string;
  
  // Usage component (usage item kind) covered by this bucket.
  // Empty unless group_by_component was set on the request.
  // string
  component?: string;
  
  // Credits consumed in this bucket.
  // number
  credits?: number;
}

// Request arguments for GetCreditUsage.
export interface GetCreditUsageRequest {
  // Request credit usage for the organization with this id.
  // This is a required field.
  // string
  organization_id?: string;
  
  // Start of the reported period (inclusive).
  // This is a required field.
  // googleTypes.Timestamp
  from?: googleTypes.Timestamp;
  
  // End of the reported period (exclusive).
  // This is a required field.
  // The period must not be longer than 366 days.
  // googleTypes.Timestamp
  to?: googleTypes.Timestamp;
  
  // Size of the returned time buckets.
  // This is an optional field, defaulting to a single total bucket.
  // Granularity
  granularity?: Granularity;
  
  // Limit the report to the deployment with this id.
  // This is an optional field.
  // string
  deployment_id?: string;
  
  // If set, return one bucket per deployment within each time bucket.
  // boolean
  group_by_deployment?: boolean;
  
  // If set, return one bucket per usage component within each time bucket.
  // boolean
  group_by_component?: boolean;
  
  // Limit the report to this usage component, e.g. "MemoryHour".
  // Must be one of the Billing 2.0 usage component kinds; an unknown value
  // is rejected rather than silently returning an empty report.
  // This is an optional field.
  // string
  component?: string;
}

// Request arguments for ListUsageItems
export interface ListUsageItemsRequest {
  // Request usage items for the organization with this id.
  // This is a required field.
  // string
  organization_id?: string;
  
  // Request usage items that overlaps in time with the time period that starts with this timestamp (inclusive).
  // This is a required field.
  // googleTypes.Timestamp
  from?: googleTypes.Timestamp;
  
  // Request usage items that overlaps in time with the time period that ends with this timestamp (exclusive).
  // This is a required field.
  // googleTypes.Timestamp
  to?: googleTypes.Timestamp;
  
  // Sort descending (new to old) on started_at field (default is ascending).
  // boolean
  sort_descending?: boolean;
  
  // Limit to usage items of this kind
  // string
  kind?: string;
  
  // Standard list options
  // This is an optional field.
  // arangodb.cloud.common.v1.ListOptions
  options?: arangodb_cloud_common_v1_ListOptions;
  
  // Limit to usage items for the resource with this URL.
  // This is an optional field.
  // string
  resource_url?: string;
  
  // Limit to usage items for the resource with this kind.
  // This is an optional field.
  // string
  resource_kind?: string;
  
  // Limit to usage items for the project with this id.
  // This is an optional field.
  // string
  project_id?: string;
  
  // Limit to usage items for the deployment with this id.
  // This is an optional field.
  // string
  deployment_id?: string;
  
  // Limit to usage items for deployments with this node size.
  // This is an optional field.
  // string
  node_size_id?: string;
  
  // Limit to usage items for deployments in this region.
  // This is an optional field.
  // string
  region_id?: string;
  
  // If set, limit to usage items that have no invoice_id set.
  // boolean
  has_no_invoice_id?: boolean;
  
  // If set, limit to usage items that have an invoice_id set.
  // boolean
  has_invoice_id?: boolean;
  
  // If set, limit to usage items that have the invoice_id set to this specific value.
  // This is an optional field.
  // string
  invoice_id?: string;
  
  // Request usage items that start at or after given timestamp.
  // This is an optional field.
  // googleTypes.Timestamp
  not_start_before?: googleTypes.Timestamp;
  
  // Limit to usage items for the deployment with this model.
  // string
  included_tier_ids?: string[];
  
  // Limit to usage items for the deployment with this model.
  // string
  excluded_tier_ids?: string[];
}

// A UsageItem message contained usage tracking information for a tracked
// resource (usually deployment) in a specific time period.
export interface UsageItem {
  // System identifier of the usage item.
  // string
  id?: string;
  
  // URL of this resource
  // string
  url?: string;
  
  // Kind of usage item.
  // Examples:
  // UsageItemKindNetworkSize (NetworkUsageSize), UsageItemKindCPUHour (CPUHour), etc.
  // string
  kind?: string;
  
  // Identification of the resource covered by this usage item
  // UsageItem_Resource
  resource?: UsageItem_Resource;
  
  // This usage item covers a time period that starts at this timestamp
  // googleTypes.Timestamp
  starts_at?: googleTypes.Timestamp;
  
  // This usage item covers a time period that ends at this timestamp.
  // If the usage item has not yet ended, this field is is set to the current time.
  // googleTypes.Timestamp
  ends_at?: googleTypes.Timestamp;
  
  // @Deprecated - will be removed in OAS-12028
  // Set when this usage item has ended.
  // boolean
  has_ended?: boolean;
  
  // Identifier of the tier the organization was using at the start of this usage period.
  // string
  tier_id?: string;
  
  // Identifier of the invoice that includes this usage item.
  // The usage item must be ended when this field it set.
  // string
  invoice_id?: string;
  
  // UsageItem creation time information
  // googleTypes.Timestamp
  created_at?: googleTypes.Timestamp;
  
  // Amount of (computer) resources used by the resource covered by this usage item.
  // This field is only set when the usage item is of kind DeploymentSize.
  // UsageItem_DeploymentSize
  deployment_size?: UsageItem_DeploymentSize;
  
  // Amount of network traffic used by the resource covered by this usage item.
  // This field is only set when the usage item is of kind NetworkTransferSize
  // (UsageItemKindNetworkTransferSize).
  // UsageItem_NetworkTransferSize
  network_transfer_size?: UsageItem_NetworkTransferSize;
  
  // Amount of backup related cloud storage used by the resource covered by this usage item.
  // This field is only set when the usage item is of kind BackupStorageSize.
  // UsageItem_BackupStorageSize
  backup_storage_size?: UsageItem_BackupStorageSize;
  
  // Amount of audit log related resources used by the resource covered by this usage item.
  // This field is only set when the usage item is of kind AuditLogSize.
  // UsageItem_AuditLogSize
  auditlog_size?: UsageItem_AuditLogSize;
  
  // Amount of audit log storage related resources used by the resource covered by this usage item.
  // This field is only set when the usage item is of kind AuditLogCloudSize.
  // UsageItem_AuditLogStorageSize
  auditlog_storage_size?: UsageItem_AuditLogStorageSize;
  
  // Amount of cloud resources used by a given Notebook.
  // This field is only set when the usage item is of kind NotebookSize.
  // UsageItem_NotebookSize
  notebook_size?: UsageItem_NotebookSize;
  
  // Amount of compute resources used by a given MLServices resource.
  // This field is only set when the usage item is of kind MLServicesSize.
  // UsageItem_MLServicesSize
  mlservices_size?: UsageItem_MLServicesSize;
  
  // Amount of compute resources used by a given ML job.
  // This field is only set when the usage item is of kind MLJobSize.
  // UsageItem_MLJobSize
  mljob_size?: UsageItem_MLJobSize;
  
  // Amount of compute resources used by a given ML job.
  // This field is only set when the usage item is of kind MLJobSize.
  // UsageItem_GraphAnalyticsJobSize
  graphanalyticsjob_size?: UsageItem_GraphAnalyticsJobSize;
  
  // This field is only set when the usage item is of kind CPUHour.
  // UsageItem_CPUHour
  cpu_hour?: UsageItem_CPUHour;
  
  // This field is only set when the usage item is of kind MemoryHour.
  // UsageItem_MemoryHour
  memory_hour?: UsageItem_MemoryHour;
  
  // This field is only set when the usage item is of kind StorageHour.
  // UsageItem_StorageHour
  storage_hour?: UsageItem_StorageHour;
  
  // This field is only set when the usage item is of kind StoragePerformanceHour.
  // UsageItem_StoragePerformanceHour
  storage_performance_hour?: UsageItem_StoragePerformanceHour;
  
  // This field is only set when the usage item is of kind GPUHour.
  // UsageItem_GPUHour
  gpu_hour?: UsageItem_GPUHour;
  
  // This field is only set when the usage item is of kind NetworkUsageSize
  // (UsageItemKindNetworkSize).
  // UsageItem_NetworkSize
  network_size?: UsageItem_NetworkSize;
  
  // This field is only set when the usage item is of kind CloudStorageHour.
  // UsageItem_CloudStorageHour
  cloud_storage_hour?: UsageItem_CloudStorageHour;
  
  // This field is only set when the usage item is of kind DeploymentAEU.
  // UsageItem_DeploymentAEU
  deployment_aeu?: UsageItem_DeploymentAEU;
  
  // This field is only set when the usage item is of kind AuditLogRequests.
  // UsageItem_AuditLogRequests
  audit_log_requests?: UsageItem_AuditLogRequests;
  
  // This field is only set when the usage item is of kind AuditLogData.
  // UsageItem_AuditLogData
  audit_log_data?: UsageItem_AuditLogData;
  
  // This field is only set when the usage item is of kind AddonHour.
  // UsageItem_AddonHour
  addon_hour?: UsageItem_AddonHour;
}
export interface UsageItem_AddonHour {
  // Identifier of the addon (e.g. "dedicateddatacluster").
  // string
  addon_id?: string;
  
  // Number of hours the addon was active in this usage period.
  // number
  addon_hours?: number;
}
export interface UsageItem_AuditLogData {
  // Number of bytes delivered as audit-log HTTPS-POST request bodies in this usage period.
  // number
  bytes?: number;
  
  // Identifier of the audit-log destination this data was delivered to
  // (AuditLog.Destination.id). See AuditLogRequests.destination_id.
  // string
  destination_id?: string;
}
export interface UsageItem_AuditLogRequests {
  // Number of audit-log HTTPS-POST delivery requests (invocations) in this usage period.
  // number
  count?: number;
  
  // Identifier of the audit-log destination these requests were delivered to
  // (AuditLog.Destination.id).
  // A deployment may have several HTTPS-POST destinations, all delivering over
  // the same period; each is charged separately, so this is what keeps their
  // usage items apart. Without it they are identical but for their quantity,
  // and everything downstream that deduplicates on (kind, resource, period) —
  // the usage store and the billing system alike — keeps only one of them.
  // string
  destination_id?: string;
}

// @Deprecated - will be removed in OAS-12028
// Amount of audit log related resources used by the resource covered by this usage item.
export interface UsageItem_AuditLogSize {
  // Type of destination.
  // Possible values are: "cloud", "https-post"
  // string
  destination_type?: string;
  
  // Number of events used by audit log.
  // This is the value of DestinationCounters.events (of the timespan covered by this usage item).
  // number
  event_count?: number;
  
  // Number of bytes used by audit log.
  // This is the total of DestinationCounters.bytes_succeeded and bytes_failed (of the timespan covered by this usage item)
  // and depending on the destination type send to the cloud or used as the body of a https post request.
  // number
  event_size?: number;
  
  // Number of https post invocations used by audit log.
  // This is the total of DestinationCounters.https_posts_succeeded and https_posts_failed (of the timespan covered by this usage item).
  // Set when destination_type is "https-post" only
  // number
  https_post_count?: number;
}

// @Deprecated - will be removed in OAS-12028
// Amount of audit log storage related resources used by the resource covered by this usage item.
// When this usage type is used, the audit log destination_type is "cloud".
export interface UsageItem_AuditLogStorageSize {
  // Amount of cloud storage (in bytes) used by audit log.
  // number
  cloud_storage_size?: number;
}

// @Deprecated - will be removed in OAS-12028
// Amount of backup related cloud storage used by the resource covered by this usage item.
export interface UsageItem_BackupStorageSize {
  // Amount of cloud storage (in bytes) used by backups of a deployment.
  // number
  cloud_storage_size?: number;
  
  // Purpose of the cloud storage.
  // Can be 'auditlogs', 'backups', 'platform', etc.
  // string
  purpose?: string;
}
export interface UsageItem_CPUHour {
  // Number of CPU hours allocated/used in this usage period.
  // number
  cpu_hours?: number;
}
export interface UsageItem_CloudStorageHour {
  // Average amount of cloud storage allocated/used during this usage period, in bytes.
  // This value is derived from the average of the cloud storage usage gauge over the covered time range.
  // number
  cloud_storage_size?: number;
  
  // Optional human-readable breakdown by storage purpose, for example:
  // "Backups: 600.00 MiB, Audit Logs: 120.00 MiB".
  // string
  purpose_breakdown?: string;
  
  // Billable cloud storage usage during this usage period, in GiB-hours.
  // This value is derived from cloud_storage_size and the duration of the covered time range (24h by default).
  // number
  gib_hours?: number;
}
export interface UsageItem_DeploymentAEU {
  // Number of deployment AEU-hours allocated/used in this usage period.
  // number
  deployment_aeu_hours?: number;
}

// @Deprecated - will be removed in OAS-12028
// Amount of (computer) resources used by the resource covered by this usage item.
export interface UsageItem_DeploymentSize {
  // Number of coordinators of the deployment
  // number
  coordinators?: number;
  
  // Amount of memory (in GB) allocated for each coordinator.
  // number
  coordinator_memory_size?: number;
  
  // Number of dbservers of the deployment
  // number
  dbservers?: number;
  
  // Amount of memory (in GB) allocated for each dbserver.
  // number
  dbserver_memory_size?: number;
  
  // Amount of disk space (in GB) allocated for each dbserver.
  // number
  dbserver_disk_size?: number;
  
  // Number of agents of the deployment
  // number
  agents?: number;
  
  // Amount of memory (in GB) allocated for each agent.
  // number
  agent_memory_size?: number;
  
  // Amount of disk space (in GB) allocated for each agent.
  // number
  agent_disk_size?: number;
  
  // Identifier of the node-size used for this deployment (empty for flexible)
  // string
  node_size_id?: string;
  
  // Identifier of disk performance used for this deployment (if any).
  // string
  disk_performance_id?: string;
  
  // List of identifiers of addons used by the deployment.
  // string
  addon_ids?: string[];
  
  // IF true the deployment was in paused state
  // boolean
  is_paused?: boolean;
  
  // Number of gateways of the deployment.
  // number
  gateways?: number;
  
  // Amount of memory (in GB) allocated for each gateway.
  // number
  gateway_memory_size?: number;
}
export interface UsageItem_GPUHour {
  // Number of GPU hours allocated/used in this usage period.
  // number
  gpu_hours?: number;
}

// @Deprecated - will be removed in OAS-12028
// Amount of compute resources used by a Graph Analytics Job.
export interface UsageItem_GraphAnalyticsJobSize {
  // Amount of memory (in GB) allocated for the job.
  // number
  memory_size?: number;
  
  // Amount of CPU units allocated to the job.
  // 1 CPU unit equals 1 physical / virtual CPU.
  // number
  cpu_size?: number;
  
  // Amount of GPU units allocated to the job.
  // 1 CPU unit equals 1 physical / virtual GPU.
  // number
  gpu_size?: number;
  
  // ID of the ML job.
  // string
  job_id?: string;
  
  // Type of Graph Analytics job.
  // string
  job_type?: string;
}

// @Deprecated - will be removed in OAS-12028
// Amount of compute resources used by a ML Job.
export interface UsageItem_MLJobSize {
  // Amount of memory (in GB) allocated for the job.
  // number
  memory_size?: number;
  
  // Amount of CPU units allocated to the job.
  // 1 CPU unit equals 1 physical / virtual CPU.
  // number
  cpu_size?: number;
  
  // Amount of GPU units allocated to the job.
  // 1 CPU unit equals 1 physical / virtual GPU.
  // number
  gpu_size?: number;
  
  // ID of the ML job.
  // string
  job_id?: string;
  
  // Type of ML Job (training, prediction, etc.)
  // string
  job_type?: string;
}

// @Deprecated - will be removed in OAS-12028
// Amount of compute resources used by a given MLServices resource.
export interface UsageItem_MLServicesSize {
  // Number of training API servers.
  // number
  training_apis?: number;
  
  // Amount of memory (in GB) allocated for each training API server.
  // number
  training_api_memory_size?: number;
  
  // Amount of CPU units allocated to the training API server.
  // 1 CPU unit equals 1 physical / virtual CPU.
  // number
  training_api_cpu_size?: number;
  
  // Number of prediction API servers.
  // number
  prediction_apis?: number;
  
  // Amount of memory (in GB) allocated for each prediction API server.
  // number
  prediction_api_memory_size?: number;
  
  // Amount of CPU units allocated to the prediction API server.
  // 1 CPU unit equals 1 physical / virtual CPU.
  // number
  prediction_api_cpu_size?: number;
  
  // Number of projects API servers.
  // number
  projects_apis?: number;
  
  // Amount of memory (in GB) allocated for each projects API server.
  // number
  projects_api_memory_size?: number;
  
  // Amount of CPU units allocated to the projects API server.
  // 1 CPU unit equals 1 physical / virtual CPU.
  // number
  projects_api_cpu_size?: number;
}
export interface UsageItem_MemoryHour {
  // Number of memory GiB hours allocated/used in this usage period.
  // number
  memory_gib_hours?: number;
}
export interface UsageItem_NetworkSize {
  // The destination (or source) the network traffic going to (or coming from).
  // Can be 'Internet', 'PrivateEndpoint' or 'InCluster'.
  // string
  destination?: string;
  
  // Total amount of network ingress traffic in bytes for the usage period.
  // number
  total_transfer_ingress_size?: number;
  
  // Total amount of network egress traffic in bytes for the usage period.
  // number
  total_transfer_egress_size?: number;
}

// @Deprecated - will be removed in OAS-12028
// Amount of network traffic used by the resource covered by this usage item.
export interface UsageItem_NetworkTransferSize {
  // The destination (or source) the network traffic going to (or coming from)
  // Can be 'Internet' or 'InCluster'
  // An empty string means 'Internet'
  // string
  destination?: string;
  
  // Total amount of network ingress traffic (in bytes) caused by the use of a deployment.
  // Destination 'Internet': This is traffic coming from the internet, so excluding inner cluster traffic
  // Destination 'InCluster': This is in-cluster traffic only
  // This is always excluding backup traffic (downloads).
  // number
  total_transfer_ingress_size?: number;
  
  // Total amount of network egress traffic (in bytes) caused by the use of a deployment.
  // Destination 'Internet': This is traffic going to the internet, so excluding inner cluster traffic
  // Destination 'InCluster': This is in-cluster traffic only
  // This is always excluding backup traffic (uploads).
  // Note: In the future we want to split between cross_region_transfer_x and inner_region_transfer_x,
  // the total_transfer_x is the sum of these 2. Inner region can be cross availability zone.
  // number
  total_transfer_egress_size?: number;
}

// @Deprecated - will be removed in OAS-12028
// Amount of cloud resources used by a given Notebook.
// This field is only set when the usage item is of kind NotebookSize.
export interface UsageItem_NotebookSize {
  // Amount of CPU units allocated to the notebook.
  // 1 CPU unit equals 1 physical / virtual CPU.
  // number
  cpu_size?: number;
  
  // Amount of memory allocated to the notebook (in GiB).
  // number
  memory_size?: number;
  
  // Size of the disk allocated to the notebook (in GiB).
  // number
  disk_size?: number;
  
  // If the Notebook is paused (Hibernated phase).
  // boolean
  is_paused?: boolean;
  
  // ID of the type of Notebook that is being used.
  // string
  notebook_model_id?: string;
  
  // Amount of GPU units allocated to the notebook.
  // 1 GPU unit equals 1 physical / virtual GPU.
  // number
  gpu_size?: number;
}
export interface UsageItem_Resource {
  // System identifier of the resource that this usage item covers.
  // string
  id?: string;
  
  // URL of the resource that this usage item covers
  // string
  url?: string;
  
  // Kind of resource that this usage item covers.
  // string
  kind?: string;
  
  // Human readable description of the resource that this usage item covers.
  // string
  description?: string;
  
  // Identifier of the organization that owns the resource that this usage item covers.
  // string
  organization_id?: string;
  
  // @Deprecated - will be removed in OAS-12028
  // Name of the organization that owns the resource that this usage item covers.
  // string
  organization_name?: string;
  
  // Identifier of the project that owns the resource that this usage item covers.
  // This field is optional when the kind is AuditLogSize, depending if the audit log is for a deployment (set) or ArangoGraph Insights Platform (empty)
  // string
  project_id?: string;
  
  // @Deprecated - will be removed in OAS-12028
  // Name of the project that owns the resource that this usage item covers.
  // This field is optional when the kind is AuditLogSize, depending if the audit log is for a deployment (set) or ArangoGraph Insights Platform (empty)
  // string
  project_name?: string;
  
  // Identifier of the deployment that owns the resource that this usage item covers.
  // This field is optional when the kind is AuditLogSize, depending if the audit log is for a deployment (set) or ArangoGraph Insights Platform (empty)
  // string
  deployment_id?: string;
  
  // @Deprecated - will be removed in OAS-12028
  // Name of the deployment that owns the resource that this usage item covers.
  // This field is optional when the kind is AuditLogSize, depending if the audit log is for a deployment (set) or ArangoGraph Insights Platform (empty)
  // string
  deployment_name?: string;
  
  // Name of the deployment member that owns the resource that this usage item covers.
  // This field is only set when the usage item is specific for a member of the deployment (e.g. network transfer)
  // string
  deployment_member_name?: string;
  
  // Identifier of the cloud provider that is used to run the deployment.
  // This field is optional when the kind is AuditLogSize, depending if the audit log is for a deployment (set) or ArangoGraph Insights Platform (empty)
  // string
  cloud_provider_id?: string;
  
  // Identifier of the cloud region that is used to run the deployment.
  // This field is optional when the kind is AuditLogSize, depending if the audit log is for a deployment (set) or ArangoGraph Insights Platform (empty)
  // string
  cloud_region_id?: string;
  
  // Identifier of the support plan that is attached to the deployment.
  // This field is not filled-out when the kind is AuditLogSize
  // string
  support_plan_id?: string;
  
  // Model of the deployment
  // This field is not filled-out when the kind is AuditLogSize
  // string
  deployment_model?: string;
  
  // Identifier of the PrepaidDeployment that this deployment is attached to (if any)
  // string
  prepaid_deployment_id?: string;
  
  // Timestamp when the prepaid_deployment starts (relevant when prepaid_deployment_id is set only)
  // googleTypes.Timestamp
  prepaid_deployment_starts_at?: googleTypes.Timestamp;
  
  // Timestamp when the prepaid_deployment ends (relevant when prepaid_deployment_id is set only)
  // googleTypes.Timestamp
  prepaid_deployment_ends_at?: googleTypes.Timestamp;
  
  // Identifiers of the credit bundles (if any) that were used to pay for this usage item.
  // string
  credit_bundle_ids?: string[];
}
export interface UsageItem_StorageHour {
  // Number of storage GiB hours allocated/used in this usage period.
  // number
  storage_gib_hours?: number;
}
export interface UsageItem_StoragePerformanceHour {
  // Number of storage performance unit-hours allocated/used in this usage period.
  // One unit is one billable data volume; the value does not depend on volume size.
  // number
  storage_performance_unit_hours?: number;
  
  // Identifier of the disk performance tier the volumes ran at (e.g. "dp30", "dp100").
  // Selects the per-tier rate when the item is priced.
  // string
  disk_performance_id?: string;
}

// List of UsageItems.
export interface UsageItemList {
  // UsageItem
  items?: UsageItem[];
}

// Granularity of the time buckets returned by GetCreditUsage.
export enum Granularity {
  // A single bucket covering the whole requested period.
  GRANULARITY_TOTAL = 0,
  
  // One bucket per UTC day.
  GRANULARITY_DAY = 1,
  
  // One bucket per UTC month.
  GRANULARITY_MONTH = 2,
}

// UsageService is the API used to fetch usage tracking information.
export interface IUsageService {
  // Get the current API version of this service.
  // Required permissions:
  // - None
  GetAPIVersion: (req?: arangodb_cloud_common_v1_Empty) => Promise<arangodb_cloud_common_v1_Version>;
  
  // Fetch all UsageItem resources in the organization identified by the given
  // organization ID that match the given criteria.
  // Required permissions:
  // - usage.usageitem.list on the organization identified by the given organization ID
  ListUsageItems: (req: ListUsageItemsRequest) => Promise<UsageItemList>;
  
  // Fetch aggregated Billing 2.0 credit consumption for the organization
  // identified by the given organization ID.
  // Only Billing 2.0 usage components are included, and usage on non-billable
  // tiers is excluded.
  // Required permissions:
  // - usage.usageitem.list on the organization identified by the given organization ID
  GetCreditUsage: (req: GetCreditUsageRequest) => Promise<CreditUsage>;
}

// UsageService is the API used to fetch usage tracking information.
export class UsageService implements IUsageService {
  // Get the current API version of this service.
  // Required permissions:
  // - None
  async GetAPIVersion(req?: arangodb_cloud_common_v1_Empty): Promise<arangodb_cloud_common_v1_Version> {
    const path = `/api/usage/v1/api-version`;
    const url = path + api.queryString(req, []);
    return api.get(url, undefined);
  }
  
  // Fetch all UsageItem resources in the organization identified by the given
  // organization ID that match the given criteria.
  // Required permissions:
  // - usage.usageitem.list on the organization identified by the given organization ID
  async ListUsageItems(req: ListUsageItemsRequest): Promise<UsageItemList> {
    const path = `/api/usage/v1/organization/${encodeURIComponent(req.organization_id || '')}/usageitems`;
    const url = path + api.queryString(req, [`organization_id`]);
    return api.get(url, undefined);
  }
  
  // Fetch aggregated Billing 2.0 credit consumption for the organization
  // identified by the given organization ID.
  // Only Billing 2.0 usage components are included, and usage on non-billable
  // tiers is excluded.
  // Required permissions:
  // - usage.usageitem.list on the organization identified by the given organization ID
  async GetCreditUsage(req: GetCreditUsageRequest): Promise<CreditUsage> {
    const path = `/api/usage/v1/organization/${encodeURIComponent(req.organization_id || '')}/creditusage`;
    const url = path + api.queryString(req, [`organization_id`]);
    return api.get(url, undefined);
  }
}
